module.exports = __webpack_public_path__ + "img/kingdom-hearts.e9c3dd25.png";